import type { ResourceHeadersPropsWithActions } from 'modules/core/lib/navigation/types'
import { recurrenceLabel } from 'modules/incentives/lib/recurrence'
import { CompensationPlanDetailRouteFragment } from 'generated/resources/graphql'
import i18n from 'modules/core/lib/i18n'
import { dateBackendToUI } from 'modules/core/lib/dates'

export const COMPENSATION_PLAN_ACTION = {
  SendToCompensation: 'incentives_send_to_compensation',
} as const

export type CompensationPlanAction =
  (typeof COMPENSATION_PLAN_ACTION)[keyof typeof COMPENSATION_PLAN_ACTION]

export const buildCompensationPlanDetailHeaderProps = (
  plan: CompensationPlanDetailRouteFragment
): ResourceHeadersPropsWithActions => {
  const primaryAction = {
    label: i18n.t('incentives.detail.send_to_compensation'),
    key: COMPENSATION_PLAN_ACTION.SendToCompensation,
    critical: true,
  }

  return {
    title: plan.name,
    primaryAction,
    metadata: [
      {
        label: i18n.t('incentives.plan.recurrence'),
        value: {
          content: recurrenceLabel(plan.recurrence),
          type: 'text',
        },
      },
      {
        label: i18n.t('incentives.plan.start_date'),
        value: {
          formattedDate: dateBackendToUI(plan.startsOn),
          type: 'date',
        },
      },
    ],
  }
}
